import React from 'react'
import AirdropCard from './AirdropCard'
import { useEffect, useState } from 'react'
import { get } from '../helpers/Api'
import { Skeleton } from '@nextui-org/react'
import MainButton from '../common/util/input/MainButton'
import { useTranslation } from 'react-i18next'

const AirdropOverview = () => {
    const [airdrops, setAirdrops] = useState([])
    const [isLoading, setLoading] = useState(true)

    const getAirdrops = () => {
        get(`get-wuffi-airdrops?limit=40`, 'legacy')
            .then((response) => setAirdrops(response))
            .catch((error) => console.error(error))
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            getAirdrops()
            setLoading(false)
        }
    }, [])

    const { t } = useTranslation('common')

    return (
        <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 sm:gap-4 mx-auto">
                {!isLoading
                    ? airdrops.map((airdrop, index) => (
                          <AirdropCard key={index} airdrop={airdrop} />
                      ))
                    : Array.from(new Array(12)).map(() => (
                          <div className="space-y-4 p-4">
                              <Skeleton className="w-full h-[200px] rounded-lg">
                                  <div className="h-24 rounded-lg bg-default-300"></div>
                              </Skeleton>
                              <Skeleton className="w-full h-[54px] rounded-lg">
                                  <div className="h-24 rounded-lg bg-default-300"></div>
                              </Skeleton>
                              <Skeleton className="w-full h-[60px] rounded-lg">
                                  <div className="h-24 rounded-lg bg-default-300"></div>
                              </Skeleton>
                              <Skeleton className="w-1/2 h-[24px] rounded-lg">
                                  <div className="h-24 rounded-lg bg-default-300"></div>
                              </Skeleton>
                          </div>
                      ))}
            </div>
            <div className={'w-full flex justify-center'}>
                <MainButton
                    padding={'px-0'}
                    fullWidth={true}
                    href={'/airdrops/new'}
                    className={'max-w-72 m-4'}
                >
                    {t('airdrops.create_new_airdrop')}
                </MainButton>
            </div>
        </div>
    )
}
export default AirdropOverview
